import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupIdChartsUninstallCacheKeys: AllRouteEndpoints[] = [];
